<template>
  <b-container fluid>
    <b-row>
      <b-col lg="3" >
        <div>
          <h1>{{ $t('privatePage.menu_login') }}</h1>
          <div>
            <b-form @submit="onSubmit" lg="3" >
              <b-form-group id="usernameGroup"
                            :label="$t('privatePage.username')"
                            label-for="usernameGroup">
                <b-form-input id="usenameInput"
                              type="text"
                              v-model="userName"
                              required
                              autocomplete="off"
                              aria-autocomplete="none"
                              :placeholder="$t('privatePage.username_enter')">
                </b-form-input>
              </b-form-group>
              <b-form-group id="passwordGroup"
                            :label="$t('privatePage.password')"
                            label-for="passwordGroup">
                <b-form-input id="passwordInput"
                              type="password"
                              v-model="password"
                              required
                              autocomplete="off"
                              aria-autocomplete="none"
                              :placeholder="$t('privatePage.password_enter')" >
                </b-form-input>
              </b-form-group>
              <b-button type="submit" variant="primary">{{$t('privatePage.menu_login')}}</b-button>
            </b-form>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'login-block',
  data() {
    return {
      userName: '',
      password: ''
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'languages'])
  },
  methods: {
    ...mapActions('testMethodsModule', {
      getQuestionFormats: 'getQuestionFormats',
      getPfdTypes: 'getPdfTypes'
    }),
    ...mapActions({ login: 'login', setSelectedCulture: 'setSelectedCulture' }),
    ...mapActions('userGroupsModule', { getMyCompany: 'getMyCompany' }),
    onSubmit(ev) {
      ev.preventDefault()

      this.login({
        UserName: this.userName,
        Password: this.password
      }).then(token => {
        let culture = this.languages.filter(
          l => l.languageId === token.languageId
        )[0]

        this.$root.$i18n.locale = culture.langCode
        this.setSelectedCulture(culture)

        this.getMyCompany().then(() => {
          this.userName = ''
          this.password = ''
          this.getPfdTypes()
          this.getQuestionFormats()
            .then(() => {
              this.$router.push({ path: '/private/status' })
            })
            .catch(() => {})
        })
      })
    }
  }
}
</script>
